import {useRoutes} from 'react-router-dom';

import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ThemeRoutes from './components/routes/Router';

const App = () => {
    const routing = useRoutes(ThemeRoutes);


    return (<>

            {routing}
            <ToastContainer rtl style={{fontFamily: 'Shabnam'}}/>
    </>);
};

export default App;
